import { Box, Input, InputGroup, InputLeftAddon } from '@chakra-ui/react';
import { useState } from 'react';
import { BsEye, BsEyeSlash } from 'react-icons/bs';

const InputText = ({ type, name, prefix, ...props }) => {
    const [togglePassword, setTogglePassword] = useState(false);
    return (
        <Box display={'inline-block'} pos={'relative'} width={'full'}>
            <InputGroup>
                {prefix && <InputLeftAddon>{prefix}</InputLeftAddon>}
                <Input
                    type={type === 'password' && togglePassword ? 'text' : type}
                    name={name}
                    {...props}
                />
            </InputGroup>
            {type === 'password' && (
                <button
                    type="button"
                    onClick={() => setTogglePassword((prev) => !prev)}
                    style={{
                        position: 'absolute',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        right: '0.25rem',
                        zIndex: 100,
                    }}>
                    {' '}
                    {togglePassword ? <BsEyeSlash /> : <BsEye />}
                </button>
            )}
        </Box>
    );
};

export default InputText;
